import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorPage from './ErrorPage';

/** Use as a child route's errorElement to keep the dashboard shell mounted. */
export default function QueryRouteErrorPage() {
  const { reset } = useQueryErrorResetBoundary();
  const location = useLocation();
  const navigate = useNavigate();

  // A later navigation must be able to retry the failed query too.
  useEffect(() => reset(), [reset]);

  const retry = () => {
    reset();
    void navigate(
      {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      },
      { replace: true, state: location.state as unknown },
    );
  };

  return <ErrorPage onRetry={retry} />;
}
